import * as _ from 'lodash';
import { PageBase, PageOptionsBase } from '../../Common/PageBase';
import { MultiSelectApi } from '../../Widgets/MultiSelect'
import { DateTimePickerApi } from '../../Widgets/DateTimePicker';
import { Utils } from '../../Utils/Utils';
import { DateUtils } from '../../Utils/DateUtils';
import { StringUtils } from '../../Utils/StringUtils';
import { StatusMessage, StatusMessageModel, StatusMessageType } from '../../Widgets/StatusMessage'
import { StatusMessageHelper } from '../../Utils/StatusMessageHelper';

export interface IndexPageOptions extends PageOptionsBase {
    urlList: string,
    urlDetailContextInformation: string,
    urlCount: string
}

var FILTER_DELIM = '-delim-';
const batchSize = 100;

class ErrorLogBrowseRequest {
    public Id: string;
    public ErrorId: string;
    public LogLevel: string;
    public TimestampFrom: number | null;
    public TimestampTo: number | null;
    public Description: string;
    public Computer: string;
    public SessionId: string;
    public FullText: string;
    public GameRoundId: string;
    public PlayerId: string;
    public Application: string;
    public ExcludedMessages: string[];

    public LastCreated: string;
    public BatchSize: number;
}

export class IndexPage {
    private _options: IndexPageOptions;
    private _runButton: JQuery;
    private _loadMoreButton: JQuery;
    private _resetFilterButton: JQuery;
    private _currentRequest: ErrorLogBrowseRequest;

    private _filterId: JQuery;
    private _filterLevel: MultiSelectApi;
    private _filterCreatedFrom: DateTimePickerApi;
    private _filterCreatedTo: DateTimePickerApi;
    private _filterComputerName: MultiSelectApi;
    private _filterSessionId: JQuery;
    private _filterErrorId: JQuery;
    private _filterMessage: JQuery;
    private _filterFullText: JQuery;
    private _filterGameRoundId: JQuery;
    private _filterPlayerId: JQuery;
    private _filterApplication: MultiSelectApi;
    private _btnCountResult: JQuery;
    private _totalEntries: JQuery;
    private _processing: JQuery;
    private _excludedMessages: string[];


    constructor(options: IndexPageOptions) {
        this._options = options;

        this.run = this.run.bind(this);
        this.showLoadMoreButton = this.showLoadMoreButton.bind(this);
        this.hideLoadMoreButton = this.hideLoadMoreButton.bind(this);
        this.enableRunButton = this.enableRunButton.bind(this);
        this.loadMore = this.loadMore.bind(this);
        this.resetFilter = this.resetFilter.bind(this);
        this.renderDetailRow = this.renderDetailRow.bind(this);
        this.renderContextData = this.renderContextData.bind(this);
        this.getCountResult = this.getCountResult.bind(this);
        this.toggleDetail = this.toggleDetail.bind(this);

        this._runButton = Utils.getJQueryById("btnRunQuery");
        this._runButton.on("click", this.run);
        this._loadMoreButton = Utils.getJQueryById("btnLoadMore");
        this._loadMoreButton.on("click", this.loadMore);
        this._resetFilterButton = Utils.getJQueryById("btnResetFilter");
        this._resetFilterButton.on("click", this.resetFilter);
        this._btnCountResult = Utils.getJQueryById("btnCountResult");
        this._btnCountResult.on("click", this.getCountResult);
        this._totalEntries = Utils.getJQueryById("totalEntries");
        this._processing = Utils.getJQueryById("processing");

        this._filterId = Utils.getJQueryById('filterId');
        this._filterLevel = new MultiSelectApi('filterLevel');
        this._filterCreatedFrom = new DateTimePickerApi('filterCreatedFrom');
        this._filterCreatedTo = new DateTimePickerApi('filterCreatedTo');
        this._filterMessage = Utils.getJQueryById('filterMessage');
        this._filterComputerName = new MultiSelectApi('filterComputerName');
        this._filterSessionId = Utils.getJQueryById('filterSessionId');
        this._filterErrorId = Utils.getJQueryById('filterErrorId');
        this._filterFullText = Utils.getJQueryById('filterFullText');
        this._filterApplication = new MultiSelectApi('filterApplication');
        this._filterGameRoundId = Utils.getJQueryById('filterGameRoundId');
        this._filterPlayerId = Utils.getJQueryById('filterPlayerId');
        this._excludedMessages = new Array();
        let that = this;
        $(document).on('click', '.messageRemove', function (e) {
            if (e.target.parentElement.hasAttribute("data-msg")) {
                var message = e.target.parentElement.attributes['data-msg'].value;
                var index = that._excludedMessages.indexOf(message);
                if (index != -1) {
                    that._excludedMessages.splice(index, 1);
                }
            }
            e.target.parentElement.parentElement.remove();
        });
        $(document).on('click', 'a.filterRecords', function (e) {
            let filterMessage = e.target.attributes['data-msg'].value;
            that.addFilterMessage(filterMessage)
        });
    }

    private addFilterMessage(filterMessage: string) {
        if (this._excludedMessages.indexOf(filterMessage) != -1) {
            return;
        }
        this._excludedMessages.push(filterMessage);
        let table = <HTMLTableSectionElement>document.getElementById("excludedMessages");
        let row = table.insertRow(-1);
        let cell0 = row.insertCell(0);
        cell0.className = "messageRemove";
        cell0.setAttribute("data-msg", filterMessage);
        cell0.innerHTML = '<i class="fa fa-remove color-red cursor-pointer" style="width: 20px;"></i>';
        let cell1 = row.insertCell(1);
        cell1.className = "messageText";
        cell1.innerHTML = `${StringUtils.escapeHtml(filterMessage)}`;
    }

    private run(): void {
        this.disableRunButton();
        let totalEntries = <HTMLSpanElement>this._totalEntries[0];
        totalEntries.innerText = "##";
        this._currentRequest = this.getBrowseRequest();
        let table = this.getTableBody();
        table.innerHTML = "";
        this.sendRequest(this._currentRequest);
    }

    private getTableBody(): HTMLTableSectionElement {
        return document.getElementById("tableLogs").getElementsByTagName("tbody")[0];
    }

    private getBrowseRequest(): ErrorLogBrowseRequest {
        let request = new ErrorLogBrowseRequest();
        request.ExcludedMessages = this._excludedMessages;
        request.Id = this._filterId.val();
        request.ErrorId = this._filterErrorId.val();
        request.LogLevel = this._filterLevel.isAllSelected() ? '' : this._filterLevel.getSelectionValues(FILTER_DELIM);
        request.TimestampFrom = this._filterCreatedFrom.getUnixTimestamp();
        request.TimestampTo = this._filterCreatedTo.getUnixTimestamp();
        request.Description = this._filterMessage.val();
        request.Computer = this._filterComputerName.isAllSelected() ? '' : this._filterComputerName.getSelectionValues(FILTER_DELIM);
        request.SessionId = this._filterSessionId.val();
        request.FullText = this._filterFullText.val();
        request.GameRoundId = this._filterGameRoundId.val();
        request.PlayerId = this._filterPlayerId.val();
        request.Application = this._filterApplication.isAllSelected() ? '' : this._filterApplication.getSelectionValues(FILTER_DELIM);
        request.BatchSize = batchSize + 1;
        return request;
    }

    private sendRequest(request: ErrorLogBrowseRequest) {
        let urlList = this._options.urlList;
        let table = this.getTableBody();
        let showLoadMore = this.showLoadMoreButton;
        let hideLoadMore = this.hideLoadMoreButton;
        let enableRunButton = this.enableRunButton;
        let processing = this._processing;
        let displayMessage = this.displayMessage;
        let renderDetailRow = this.renderDetailRow;
        let toggleDetail = this.toggleDetail;
        var jsonData = JSON.stringify(request);
        processing.show();
        $.ajax({
            url: urlList,
            type: "POST",
            dataType: 'json',
            contentType: "application/json",
            data: jsonData,
            success: function (data) {
                let items = data;
                if (items.length < batchSize + 1) {
                    hideLoadMore();
                }
                else {
                    request.LastCreated = items[batchSize].CreatedTicks;
                    showLoadMore();
                }
                $.each(items, function (index, item) {
                    if (index < batchSize) {
                        let row = table.insertRow(-1);
                        row.id = `logEntry${item.Id}`;
                        row.className = "cursor-pointer";
                        row.onclick = () => toggleDetail(row.id);
                        let cell0 = row.insertCell(0);
                        cell0.innerHTML = `${item.Id}<br /> <a class='errorIdLink' id='lnkName${item.ErrorId}' href='Logs/Detail/${item.ErrorId}'>${item.ErrorId}</a>`;
                        cell0.className = `log-level-${item.Level.toLowerCase()}`;
                        let cell1 = row.insertCell(1);
                        cell1.innerHTML = `<span>${item.Level}</span>`;
                        let cell2 = row.insertCell(2);
                        cell2.innerHTML = `${item.Created}`;
                        let cell3 = row.insertCell(3);
                        cell3.innerHTML = `${item.ComputerName}<br/>${item.Application}`;
                        let cell4 = row.insertCell(4);
                        cell4.innerHTML = `${item.SessionId}`;
                        let cell5 = row.insertCell(5);
                        cell5.innerHTML = `${StringUtils.escapeHtml(item.Message)}`;

                        let detailRow = table.insertRow(-1);
                        detailRow.setAttribute("style", "display: none");
                        detailRow.id = `logEntry${item.Id}detail`;
                        let detailCell = detailRow.insertCell(0);
                        detailCell.colSpan = 6;
                        detailCell.innerHTML = renderDetailRow(item);
                    }
                });
                processing.hide();
                enableRunButton();
            },
            error: function (jqXHR, textStatus, errorThrown) {
                processing.hide();
                enableRunButton();
                displayMessage(jqXHR);
            }
        });
    }

    private toggleDetail(id: string) {
        let detailId = `${id}detail`;
        let detailRow = document.getElementById(detailId);
        if (detailRow.hasAttribute("style")) {
            detailRow.removeAttribute("style");
        }
        else {
            detailRow.setAttribute("style", "display: none");
        }
    }

    private displayMessage(jqXHR: JQueryXHR): void {
        var statusMessageWrapper = Utils.getJQueryById("statusMessageWrapper");
        let statusMessageData = <StatusMessageModel>{
            code: jqXHR.status.toString(),
            autoClose: false,
            class: "danger",
            message: jqXHR.statusText,
            type: StatusMessageType.Error
        };
        var statusMessage = new StatusMessage(statusMessageData);
        statusMessageWrapper.html(statusMessage.getHTMLmessage());
        StatusMessageHelper.initValidator();
        StatusMessageHelper.initSatusMessage();
    }

    private showLoadMoreButton(): void {
        this._loadMoreButton.removeClass("display-none");
    }

    private hideLoadMoreButton(): void {
        this._loadMoreButton.addClass("display-none");
    }

    private disableRunButton(): void {
        this._runButton.attr("disabled", 1);
    }

    private enableRunButton(): void {
        this._runButton.removeAttr("disabled");
    }

    private loadMore(): void {
        this._currentRequest.ExcludedMessages = this._excludedMessages;
        this.sendRequest(this._currentRequest);
    }

    private resetFilter(): void {
        this._excludedMessages = new Array();
        let table = <HTMLTableSectionElement>document.getElementById("excludedMessages");
        table.innerHTML = '';
        this._filterId.val('');
        this._filterLevel.selectAll();
        this._filterLevel.setSelectionValues("Warning;Error;Critical");
        var createdFrom = DateUtils.getUtcMoment().subtract(7, 'days').set({ hours: 0, minutes: 0, seconds: 0 });
        this._filterCreatedFrom.setUTCDate(createdFrom);

        var createdTo = DateUtils.getUtcMoment().endOf('day');
        this._filterCreatedTo.setUTCDate(createdTo);

        this._filterMessage.val('');
        this._filterComputerName.selectAll();
        this._filterSessionId.val('');
        this._filterErrorId.val('');
        this._filterFullText.val('');
        this._filterGameRoundId.val('');
        this._filterPlayerId.val('');
        this._filterApplication.selectAll();
    }

    private renderDetailRow(data: any): string {
        var exceptionData = _.escape(data.ExceptionData);
        var css = data.Level.toLowerCase();
        if (css === 'error' || css === 'critical') {
            css = 'danger';
        } else if (css === 'information') {
            css = 'info';
        }

        var result = `<div class='note note-${css}'>
                    <p>&nbsp;</p>
                    <h5>Category</h5>
                    <p>${data.CategoryName}</p>
                    <p>&nbsp;</p>`;

        if (!StringUtils.isNullOrEmpty(data.ExceptionData) ||
            !StringUtils.isNullOrEmpty(data.ContextData)) {
            result += `<h5>Context</h5>
                    <p>${this.renderContextData(data.ContextData)}</p>
                    <p>&nbsp;</p>
                    <h5>Exception</h5>
                    <p class="errorLogContextData">${exceptionData}</p>
                    <p>&nbsp;</p>`;
        }

        result += `<a id="GenerateAccessLinkButton_${data.Id}" href="${this._options.urlDetailContextInformation}/?id=${data.Id}&type=1">Generate context information</a>`;
        result += `<a id="filterRecord_${data.Id}" style="margin-left: 20px;" class="filterRecords" data-msg="${data.Message}">Filter out identical records</a>`
        result += '</div>';

        return result;
    }

    private renderContextData(contextData: string) {
        var json: Object = null;
        try {
            json = JSON.parse(contextData);
        } catch (e) {
            json = null;
        }

        var result = '';
        if (json === null || !_.isArray(json)) {
            result = contextData;
        } else {
            result = '<table class="errorLogContextData table-bordered table-hover">';
            _.each(json, item => {
                for (var key in item) {
                    result += `<tr><td>${key}</td><td>${StringUtils.escapeHtml(item[key])}</td></tr>`;
                }
            });

            result += '</table>';
        }

        return result;
    }

    private getCountResult() {
        let request = Utils.isNullOrUndefined(this._currentRequest) ? this.getBrowseRequest() : this._currentRequest;
        request.ExcludedMessages = this._excludedMessages;
        let urlCount = this._options.urlCount;
        let totalEntries = <HTMLSpanElement>this._totalEntries[0];
        let processing = this._processing;
        let displayMessage = this.displayMessage;
        var jsonData = JSON.stringify(request);
        processing.show();
        $.ajax({
            url: urlCount,
            type: "POST",
            dataType: 'json',
            contentType: "application/json",
            data: jsonData,
            success: function (data) {
                totalEntries.innerText = data;
                processing.hide();
            },
            error: function (jqXHR, textStatus, errorThrown) {
                processing.hide();
                displayMessage(jqXHR);
            }
        });
    }
}


/** WEBPACK FOOTER **
 ** ./Typescript/Pages/ErrorLog/IndexPage.ts
 **/